export { default } from './RootRef';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/RootRef/index.js
// module id = 811
// module chunks = 121